import script from "./OrderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=de678b6c&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de678b6c"]])

export default __exports__